import styled from "styled-components";

export const FrontSide = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--text-color);
`;

export const BackSide = styled.div`
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  transition: 1s ease-in-out;
  opacity: 0;
  background-image: url("/assets/images/custome-bg.svg");
  background-position: right;
  transform: rotateY(180deg);
`;

export const Wrapper = styled.div`
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  height: 400px;
  max-width: 350px;

  &:hover {
    ${FrontSide} {
      /* animation-delay: 1s, 250ms; */
      transform: rotateY(180deg);
      opacity: 0;
    }
    ${BackSide} {
      transform: rotateY(0deg);
      opacity: 1;
      transition-duration: 1.5s;
    }
  }
  &:not(:hover) {
    ${BackSide} {
      opacity: 0;
    }
    ${FrontSide} {
      transition-duration: 1.5s;
      opacity: 1;
    }
  }
`;

export const CompanyName = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--black);
  h3 {
    color: var(--white);
    line-height: 0;
    margin: 0;
  }
`;

export const ExperienceInfo = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;

  h5 {
    color: var(--white);
    text-align: center;
  }
  button {
    width: 150px;
    text-align: center;
    color: white;
    padding: 0.5rem 0px;
    margin: 0 auto;
    text-transform: uppercase;
  }
`;

export const Location = styled.div`
  display: flex;
  gap: 4px;
  justify-content: start;
  align-items: start;
  .factory-icon {
    width: 24px;
    height: 24px;
    color: var(--text-secondary-color);
  }
  p {
    color: var(--text-secondary-color);
  }
`;
